(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cfg = window.SS || {};

  /* ---------- Intro (logo draw), once per visit ---------- */
  var preloader = document.querySelector('.preloader');
  function startPage() {
    root.classList.add('is-ready');
    if (preloader) setTimeout(function () { preloader.remove(); }, 1200);
  }
  if (preloader && !reduce && !root.classList.contains('no-preloader')) {
    try { sessionStorage.setItem('ss-loaded', '1'); } catch (e) {}
    setTimeout(function () { root.classList.add('preloader-done'); startPage(); }, 1500);
  } else {
    if (preloader) preloader.remove();
    requestAnimationFrame(startPage);
  }

  /* ---------- Smooth scroll ---------- */
  var lenis = null;
  if (cfg.smooth !== false && !reduce && typeof window.Lenis === 'function') {
    lenis = new window.Lenis({ duration: 1.15, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var el = document.querySelector(id);
        if (!el) return;
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      });
    });
  }

  /* ---------- Split hero headline into masked words ---------- */
  document.querySelectorAll('[data-split]').forEach(function (el) {
    var i = 0;
    function wrap(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var outer = document.createElement('span'); outer.className = 'w';
            var inner = document.createElement('span'); inner.className = 'w__i';
            inner.style.setProperty('--wi', i++);
            inner.textContent = part; outer.appendChild(inner); frag.appendChild(outer);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1) { wrap(child); }
      });
    }
    wrap(el);
    el.classList.add('is-split');
  });

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  var header = document.querySelector('.site-header');
  var lastY = 0;
  function onScrollHeader(y) {
    if (!header) return;
    header.classList.toggle('is-scrolled', y > 20);
    if (y > 240 && y > lastY + 4) header.classList.add('is-hidden');
    else if (y < lastY - 4 || y < 240) header.classList.remove('is-hidden');
    lastY = y;
  }

  /* ---------- Parallax ---------- */
  var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  function onScrollParallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    parallax.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
      var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
      el.style.setProperty('--py', (progress * speed * -100).toFixed(2) + 'px');
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset;
      onScrollHeader(y);
      onScrollParallax();
      ticking = false;
    });
  }
  if (lenis) lenis.on('scroll', onScroll); else window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Staggered reveal ---------- */
  document.querySelectorAll('[data-stagger]').forEach(function (group) {
    Array.prototype.slice.call(group.children).forEach(function (child, idx) {
      child.style.setProperty('--i', idx);
    });
  });
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Count-up numbers (e.g. "13 g") ---------- */
  document.querySelectorAll('[data-count]').forEach(function (el) {
    var m = el.textContent.trim().match(/^(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m || reduce) return;
    var target = parseFloat(m[1].replace(',', '.')), suffix = m[2], decimals = (m[1].split(/[.,]/)[1] || '').length;
    el.textContent = (0).toFixed(decimals) + suffix;
    var run = function () {
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - p, 4);
        el.textContent = (target * e).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    setTimeout(run, root.classList.contains('no-preloader') ? 900 : 2300);
  });

  /* ---------- Tilt + spotlight on cards ---------- */
  if (finePointer && !reduce && cfg.tilt !== false) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var rect = null;
      card.addEventListener('pointerenter', function () { rect = card.getBoundingClientRect(); card.classList.add('is-tilting'); });
      card.addEventListener('pointermove', function (e) {
        if (!rect) rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width, y = (e.clientY - rect.top) / rect.height;
        card.style.setProperty('--rx', ((0.5 - y) * 6).toFixed(2) + 'deg');
        card.style.setProperty('--ry', ((x - 0.5) * 8).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        rect = null; card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      });
    });

    /* Magnetic buttons */
    document.querySelectorAll('.btn').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15).toFixed(1) + 'px,' + (y * 0.25).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    btn.addEventListener('click', function () {
      var open = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Logo upload: show file name ---------- */
  document.querySelectorAll('[data-file-drop]').forEach(function (drop) {
    var input = drop.querySelector('input[type="file"]');
    var label = drop.querySelector('[data-file-name]');
    if (!input || !label) return;
    var original = label.innerHTML;
    input.addEventListener('change', function () {
      if (input.files && input.files[0]) {
        if (input.files[0].size > 20 * 1024 * 1024) {
          input.value = ''; label.innerHTML = original;
          alert(drop.getAttribute('data-too-large') || 'File too large (max 20 MB).');
          return;
        }
        label.textContent = input.files[0].name;
        drop.classList.add('has-file');
      } else { label.innerHTML = original; drop.classList.remove('has-file'); }
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.classList.add('is-swapping');
        setTimeout(function () {
          main.src = thumb.getAttribute('data-src');
          main.removeAttribute('srcset');
          main.alt = thumb.getAttribute('data-alt') || '';
          main.onload = function () { main.classList.remove('is-swapping'); };
          setTimeout(function () { main.classList.remove('is-swapping'); }, 400);
        }, 220);
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Prevent double submit ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    });
  });
})();
